// Traffic telemetry (admin JWT). Mirrors UsageDailyService / GET /admin/usage/traffic.
// Per-org daily message-volume + active-agent counters the relay pushes; EMPTY until
// the relay reports them. Zod-validated at the boundary (ContractError on drift).
import { z } from "zod";
import { apiFetch } from "./client";

export interface TrafficPoint {
  /** UTC calendar date, "YYYY-MM-DD". */
  date: string;
  messages: number;
  activeAgents: number;
}

export interface TrafficReport {
  rangeDays: number;
  /** One point per day with telemetry, ascending. Sparse — no zero-fill. */
  points: TrafficPoint[];
}

const pointSchema = z.object({ date: z.string(), messages: z.number(), activeAgents: z.number() });
const reportSchema = z.object({ rangeDays: z.number(), points: z.array(pointSchema) });

/** Daily traffic for the caller's org. `days` clamps 1..90 (API default 30). */
export function getTraffic(days?: number, signal?: AbortSignal): Promise<TrafficReport> {
  const q = days ? `?days=${encodeURIComponent(days)}` : "";
  return apiFetch(`/admin/usage/traffic${q}`, { auth: true, signal, schema: reportSchema });
}
